import axiosInstance from '../utils/axiosConfig'
import { mobileBackendUrl } from '../env'
import { FDInvestmentJourneyResponseType } from '../types/fd-type'

export const fetchInvestmentJourney = async (planId: string): Promise<FDInvestmentJourneyResponseType> => {
  return axiosInstance.get(`${mobileBackendUrl}/v2/power-fd/investment-journey/${planId}`)
}
